import {ReactNode} from 'react';

import {InlineDataComponentRegistry} from '@stripe-internal/inline-data';

import {InlineDataProviderBase} from '../../core/providers/InlineDataProvider';
import {useThreadsApp} from '../app/hooks';

type Props = {
  components?: InlineDataComponentRegistry;
  children: ReactNode;
};

export function ThreadsInlineDataProvider({components = {}, children}: Props) {
  const app = useThreadsApp();
  const source = app.runtime === 'legacy' ? app.conversations : app.transports;
  return (
    <InlineDataProviderBase
      bus={source.inlineDataEventBus}
      service={source.inlineDataService}
      components={components}
    >
      {children}
    </InlineDataProviderBase>
  );
}
